export {};
//# sourceMappingURL=promised-data-view-element-type-encoder-id-and-port.js.map